// Generic import
import _ from 'lodash';

// MUI Imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// FontAwesomeIcon import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlane, faShip, faTruck } from '@fortawesome/free-solid-svg-icons';

// Local import
import LegEditor from '../../LegEditor.js'
import TransportationMethod from '../../TransportationMethod.js';

function OpportunityRoutesPane(props) {
    const { mode, routes, setRoutes, seaPorts, unlocode, transportationMethod, setTransportationMethod, organization, accesstoken, disabledTransportationMethods, disabledTransportationMethodsTooltip } = props;

    if (mode === 'contract') {
        return (
            <div style={{ paddingTop: '16px' }}>
                {!!transportationMethod && (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {transportationMethod === 'sea' && ( <b><FontAwesomeIcon icon={faShip} />&nbsp;By Sea</b>)}
                        {transportationMethod === 'air' && ( <b><FontAwesomeIcon icon={faPlane} />&nbsp;By Air</b>)}
                        {transportationMethod === 'land' && ( <b><FontAwesomeIcon icon={faTruck} />&nbsp;By Land</b>)}
                        &nbsp;
                        &nbsp;
                        {!!setTransportationMethod && (
                            <Button
                                onClick={() => setTransportationMethod(null)}
                                variant='text' color='primary' sx={{ textTransform: 'none', textDecoration: 'underline', margin: '0px', padding: '0px' }}
                            >
                                Change
                            </Button>
                        )}
                    </Box>
                )}
                {!transportationMethod && (
                    <>
                        <TransportationMethod
                            disabled={!setTransportationMethod}
                            transportationMethod={transportationMethod}
                            setTransportationMethod={(v) => {
                                setTransportationMethod(v);
                            }}
                            disabledMethods={disabledTransportationMethods}
                            disabledMethodsTooltip={disabledTransportationMethodsTooltip}
                        />
                        <Box sx={{ mt: '10px', px: '8px', fontSize: '12px', lineHeight: 1.5, color: '#64748b', fontFamily: 'Poppins, sans-serif' }}>
                            <b>By Land</b> — road transport: a standalone port-to-door drayage/cartage quote (containers &amp; LCL) or domestic trucking. For the road leg of a sea/air shipment, choose Sea or Air and add the trucking as a cost line instead.
                        </Box>
                    </>
                )}
            </div>
        );
    }
    return (
        <LegEditor
            transportationMethod={transportationMethod}
            routes={_.isEmpty(routes) ? [{ source: null, destination: null }] : routes}
            setRoutes={setRoutes}
            setTransportationMethod={setTransportationMethod}
            autoPopulateSource={true}
            seaPorts={seaPorts}
            unlocode={unlocode}
            organization={organization}
            accesstoken={accesstoken}
            disabledTransportationMethods={disabledTransportationMethods}
            disabledTransportationMethodsTooltip={disabledTransportationMethodsTooltip}
        />
    );
}

export default OpportunityRoutesPane;
